import { useSelector } from 'react-redux';
import { StateType } from 'src/redux/reducers';
import { Role, RoleEnum } from 'src/redux/reducers/user';

const useAuth = () => {
  const { auth } = useSelector((state: StateType) => state.user);

  const getUserLabel = () =>
    auth && (auth.workspace?.name ? `${auth.name} (${auth.workspace.name})` : auth.name);

  const hasAllRoles = (roles: Role[]) => roles.every((role) => auth.roles?.includes(role));

  const hasAnyRole = (roles: Role[]) => roles.some((role) => auth.roles?.includes(role));

  const isBetaUser = () => hasAnyRole(['superadmin', 'beta']);

  return {
    auth,
    getUserLabel,
    hasAllRoles,
    hasAnyRole,
    isBetaUser,
  };
};

export default useAuth;
export type { Role };
export { RoleEnum };
